module.exports = __webpack_public_path__ + "static/fish-40-3c8b5d837db328d77838d86d5882238f.jpg";